import { CameraType } from '@/types/creator';
import { em } from '@mantine/core';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	Z_INDEX: {
		CSS_2D_RENDERER: 5,
		TOOLBAR: 10,
		OVERLAY: 50,
		SCROLL_TOP: 50,
		NOTIFICATION: 100,
		DRAWER: 301,
		MODAL: 301,
		POPOVER: 302,
		TOOLTIP: 302,
		SELECT: 302,
		CREATOR_LOADING: 303,
		MODEL_VIEWER: 304,
		MODAL_INSTRUCTION: 504,
	},
	BREAKPOINTS: {
		XS: em(576),
		SM: em(768),
		MD: em(992),
		LG: em(1200),
		XL: em(1408),
	},
	DEFAULT_LANGUAGE: 'PL',
	DEFAULT_CAMERA: CameraType.ORTHOGRAPHIC,
	PREVIEW_PARAM: 'preview_project',
	COMPANY_CONTACT: {
		EMAIL: 'listonosz@funplay.pl',
		PHONE: '+48 534 930 620',
	},
	AUTO_SAVE: {
		KEY: 'tempProject',
		INTERVAL: import.meta.env.DEV ? 3_000 : 30_000,
	},
	ROOM_HEIGHT: {
		MIN: 150,
		MAX: 1000,
		DEFAULT: 500,
	},
	CREATOR_MODULES_HISTORY_LIMIT: 10,
} as const;

export default APP_CONFIG;
